import { StringFormatter } from '@agoda/react-handyman';
import { Location } from 'gql/autogen/Location';
import { ItineraryDay } from 'gql/autogen/ItineraryDay';
import { ItineraryItem } from 'gql/autogen/ItineraryItem';
import { ItineraryReference } from 'gql/autogen/ItineraryReference';
import { Media } from 'gql/autogen/Media';
import { MediaType } from 'gql/autogen/MediaType';
import { mapDescription, mapTitle } from 'gql/service/graph/activityService';
import { SingleDayItineraryProps } from 'component/page/detail/Itineraries/StructuredItinerary/ItineraryStep';
import { CmsValue } from 'core/type/BootstrapConfig.types';
import getDurationText from 'core/utils/getDurationText';

export interface StructuredItineraryProps {
    days: SingleDayItineraryProps[];
    dayNumber: number;
    noOfStops: number;
    title: string;
    description: string;
}

const getTitle = (item: ItineraryItem, location: Location[]): string => {
    if (item.description && item.description.section && item.description.section[0] && item.description.section[0].title) {
        return item.description.section[0].title;
    }
    const poi = item && item.pointsOfInterest?.length && item.pointsOfInterest;
    if (poi) {
        const refId = poi && poi[0].locationRefId;
        const loc = location.find((x) => x.id === refId);
        return (loc && loc.name) || '';
    }
    return '';
};

const getDayTitle = (cms: CmsValue, itineraryDay: ItineraryDay) => {
    return `${StringFormatter.format(cms[130823], itineraryDay.dayNumber?.toString() ?? '0')} ${mapTitle(itineraryDay.description)}`;
};

const getADayDescription = (item: ItineraryItem) => {
    return mapDescription(item.description);
};

const getAdmissionCms = (admissionIncluded: boolean | undefined, cms: CmsValue) => {
    if (admissionIncluded != null) return admissionIncluded ? cms[130709] : cms[130708];
    return '';
};

const getMedia = (item: ItineraryItem): Media[] => {
    return (item && item.media && item.media.filter((m: Media) => m.source && m.mediaType === MediaType.IMAGE)) || ([] as Media[]);
};

const mapDayItineraryToProps = (item: ItineraryItem, location: Location[], cms: CmsValue): SingleDayItineraryProps => {
    const admission = getAdmissionCms(item.admissionIncluded, cms);
    return {
        title: getTitle(item, location),
        description: getADayDescription(item),
        duration: item && item.duration ? getDurationText(item.duration, cms) : '',
        admission,
        media: getMedia(item),
    };
};

export const mapStructuredItineraryToProps = (itinerary: ItineraryReference, cms: CmsValue, location: Location[]): StructuredItineraryProps[] => {
    if (!itinerary || !itinerary.itineraryDays || itinerary.itineraryDays.length === 0) {
        return [];
    }

    return itinerary.itineraryDays
        .filter((day: ItineraryDay) => day.itineraries && day.itineraries.length > 0)
        .map((itineraryDay: ItineraryDay): StructuredItineraryProps => {
            const itineraries = itineraryDay.itineraries || [];
            return {
                description: mapDescription(itineraryDay.description), // TODO: Map correct description to structured itinerary.
                days: itineraries.map((item: ItineraryItem) => mapDayItineraryToProps(item, location, cms)),
                dayNumber: itineraryDay.dayNumber || 0,
                noOfStops: itineraries.length,
                title: getDayTitle(cms, itineraryDay),
            };
        });
};
